import { jsx as _jsx } from "react/jsx-runtime";
import { Chip } from 'ml-rubiks-styleguide';
import { injectTSDI } from 'ml-webclient-common/src/tsdi';
import { I18nStore } from '../../core/i18n';
const STATUS_TRANSLATIONS = {
    CONFIRMED: 'ffl.payment.instrument.status.confirmed',
    INVALID: 'ffl.payment.instrument.status.invalid',
    WAITING_FOR_CONFIRMATION: 'ffl.payment.instrument.status.pending',
    IMPORTED_WAITING_FOR_PROCESSING: 'ffl.payment.instrument.status.pending'
};
const STATUS_COLORS = {
    CONFIRMED: 'success',
    INVALID: 'error',
    WAITING_FOR_CONFIRMATION: 'warning',
    IMPORTED_WAITING_FOR_PROCESSING: 'warning'
};
const FALLBACK_LABELS = {
    CONFIRMED: 'Confirmed',
    INVALID: 'Invalid',
    WAITING_FOR_CONFIRMATION: 'Pending',
    IMPORTED_WAITING_FOR_PROCESSING: 'Processing'
};
export function PaymentStatusBadge({ status }) {
    const i18n = injectTSDI(I18nStore);
    if (!status) {
        return null;
    }
    const translationKey = STATUS_TRANSLATIONS[status];
    const color = STATUS_COLORS[status];
    const label = i18n.__(translationKey) || FALLBACK_LABELS[status];
    return (_jsx(Chip, { label: label, color: color, size: "small", sx: {
            borderRadius: 1,
            fontWeight: 600,
            textTransform: 'capitalize'
        } }));
}
